
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取纪念馆组照片集合
    GetImageGroupList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Image/ImageGroup',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取纪念馆照片集合
    GetImageImageSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Image/ImageSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetImageImageSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Image/ImageSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    ImageseGroupAddVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Image/ImageseGroupAddVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    ImageImagesGroupDelectVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Image/ImagesGroupDelectVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 添加照片
    ImageImagesAddVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Image/ImagesAddVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 删除照片
    ImageImagesDelectVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/Image/ImagesDelectVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
